import React from 'react';
import PlusIcon from '@rsuite/icons/Plus';
import SearchIcon from '@rsuite/icons/Search';
import { NotificationContainer } from 'react-notifications';
import '../style.css';
import ProdutosMontagem from './ProdutosMontagem';
import { useConfig } from '../../hooks/config';
import { Container, InputGroup, Table } from 'rsuite';
import { CreateEditMount } from './CreateEditMount';
import { ContentHeader } from '../../components/ContentHeader';
import DuvidasButton from '../../components/DuvidasButton';
import { CustomInput } from '../../components/CustomInput';
import { CustomSelectPicker } from '../../components/CustomSelectPicker';
import { CustomButton } from '../../components/CustomButton';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomCell } from '../../components/CustomCell';
import { CustomHeaderCell } from '../../components/CustomHeaderCell';
import { useMounting } from './useMounting';
import { FaUtensils } from 'react-icons/fa';

const { Column } = Table;

const dataAtivos = [
  { label: 'Ver todos', value: '' },
  { label: 'Filtrar: Ativos', value: '1' },
  { label: 'Filtrar: Inativos', value: '0' },
];

const Montagem = () => {
  const { theme } = useCustomTheme();
  const { config } = useConfig();
  const {
    montagens,
    produtos,
    loading,
    modalProdutos,
    setModalProdutos,
    modalMontagem,
    setModalMontagem,
    setFiltroStatus,
    montagem,
    setMontagem,
    alterarStatusMontagem,
    id_empresa,
    debounceSearch,
    filtroStatus,
    setMontagens,
  } = useMounting();

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Montagem de Prato"
        subtitle="Gerencie as montagens de pratos do cardápio"
        icon={FaUtensils}
        secondComponent={
          <InputGroup
            inside
            style={{
              width: '36vw',
              background: theme.colors.background,
              border: 'none',
            }}
          >
            <CustomInput onChange={debounceSearch} />
            <InputGroup.Addon>
              <SearchIcon color={theme.colors.textSecondary} />
            </InputGroup.Addon>
          </InputGroup>
        }
        thirdComponent={
          <>
            <CustomSelectPicker
              data={dataAtivos}
              defaultValue={'Ativos'}
              value={filtroStatus}
              onChange={(value) => setFiltroStatus(value)}
              style={{ marginRight: '10px' }}
              searchable={false}
            />
            <CustomButton
              appearance="primary"
              onClick={() => {
                setModalMontagem(true);
                setMontagem(null);
              }}
            >
              <PlusIcon style={{ marginRight: 6 }} /> Cadastrar
            </CustomButton>
            <DuvidasButton tela="montagem" />
          </>
        }
      />

      <Table
        height={window.innerHeight - 60 - 90}
        bordered={true}
        loading={loading}
        data={montagens}
        width={'100%'}
        style={{
          overflowY: 'auto',
          borderColor: theme.colors.background,
          backgroundColor: theme.colors.background,
          color: theme.colors.textSecondary,
        }}
        locale={{
          emptyMessage: 'Nenhuma montagem encontrada',
          loading: 'Carregando...',
        }}
      >
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          align="center"
          fixed
        >
          <CustomHeaderCell>Código</CustomHeaderCell>
          <CustomCell dataKey="Id" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
        >
          <CustomHeaderCell>Codigo PDV</CustomHeaderCell>
          <CustomCell dataKey="CodigoPDV" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Descricao</CustomHeaderCell>
          <CustomCell dataKey="Descricao" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Qtd. Sem Custo</CustomHeaderCell>
          <CustomCell dataKey="QtdSemCusto" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
        >
          <CustomHeaderCell>Qtd. Min</CustomHeaderCell>
          <CustomCell dataKey="QtdMin" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
        >
          <CustomHeaderCell>Qtd. Max</CustomHeaderCell>
          <CustomCell dataKey="QtdMax" />
        </Column>
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={100}
          fixed="right"
        >
          <CustomHeaderCell>Ativo</CustomHeaderCell>
          <CustomCell dataKey="Fim">
            {(rowData) => (
              <span style={{ padding: 0 }}>
                {rowData.Ativo ? (
                  <CustomButton
                    appearance="primary"
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      width: 50,
                    }}
                    onClick={() => alterarStatusMontagem(rowData.Id, false)}
                  >
                    {' '}
                    Sim{' '}
                  </CustomButton>
                ) : (
                  <CustomButton
                    appearance="ghost"
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      width: 50,
                    }}
                    onClick={() => alterarStatusMontagem(rowData.Id, true)}
                  >
                    {' '}
                    Não{' '}
                  </CustomButton>
                )}
              </span>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={250}
          fixed="right"
        >
          <CustomHeaderCell>Opções</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <>
                <span>
                  <CustomButton
                    color={theme.colors.warning}
                    appearance="ghost"
                    size="xs"
                    onClick={() => {
                      setMontagem(rowData);
                      setModalMontagem(true);
                    }}
                  >
                    {' '}
                    Editar{' '}
                  </CustomButton>
                  {' | '}
                  <CustomButton
                    onClick={() => {
                      setMontagem(rowData);
                      setModalProdutos(true);
                    }}
                    appearance="ghost"
                    size="xs"
                  >
                    {' '}
                    Produtos{' '}
                  </CustomButton>
                </span>
              </>
            )}
          </CustomCell>
        </Column>
      </Table>
      {modalMontagem && (
        <CreateEditMount
          modal={modalMontagem}
          close={() => setModalMontagem(false)}
          montagem={montagem}
          setMontagens={setMontagens}
          id_empresa={id_empresa}
        />
      )}

      {modalProdutos && (
        <ProdutosMontagem
          modal={modalProdutos}
          close={() => setModalProdutos(false)}
          montagem={montagem}
          IdEmpresa={id_empresa}
          produtos={produtos}
          config={config}
        />
      )}
      <NotificationContainer />
    </Container>
  );
};

export default Montagem;
